export default __webpack_public_path__ + "imgs/ceremony_icon.svg";